// import { useEffect, useState } from "react";
// import { useParams } from "react-router-dom";

// import styles from "./HotelDetails.module.css";
// import PageMeta from "../Breadcrumb/PageMeta";
// import Breadcrumb from "../Breadcrumb/Breadcrumb";
// import BallroomGrid from "../BallroomGrid/BallroomGrid";
// import TableOfContents from "../TableOfContents/TableOfContents";
// import Inventory from "../Inventory/Inventory";
// import VenueSpaces from "../VenueSpaces/VenueSpaces";
// import { getVenuePlannerData } from "../venuePlannerApi";
// import HotelHero from "./HotelHero";
// import HotelSuggestionForm from "../HotelSuggestions/HotelSuggestionForm";


// export default function HotelDetails() {
//   const { hotelSlug } = useParams();

//   const [hotel, setHotel] = useState(null);
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     let isMounted = true;

//     const loadHotel = async () => {
//       try {
//         setLoading(true);

//         const hotels = await getVenuePlannerData();

//         const selectedHotel = hotels.find(
//           (item) => item.slug === hotelSlug
//         );

//         if (isMounted) {
//           setHotel(selectedHotel || null);
//         }
//       } catch (err) {
//         console.error("Failed to load hotel details:", err);

//         if (isMounted) {
//           setHotel(null);
//         }
//       } finally {
//         if (isMounted) {
//           setLoading(false);
//         }
//       }
//     };

//     loadHotel();

//     return () => {
//       isMounted = false;
//     };
//   }, [hotelSlug]);

//   if (loading) {
//     return <div>Loading...</div>;
//   }

//   if (!hotel) {
//     return <div>Hotel not found.</div>;
//   }

//   const hasInventory =
//     hotel.inventory &&
//     Object.keys(hotel.inventory).length > 0;

//   const hasVenueSpaces =
//     hotel.venue_spaces?.length > 0;

//   const hasBallrooms =
//     hotel.ballrooms?.length > 0;

//   const tableOfContents = [
//     {
//       id: "overview",
//       label: "Overview",
//     },
//     hasInventory && {
//       id: "inventory",
//       label: "Hotel Inventory",
//     },
//     hasVenueSpaces && {
//       id: "venue-spaces",
//       label: "Venue Spaces",
//     },
//     hasBallrooms && {
//       id: "ballrooms",
//       label: "Ballrooms",
//     },
//   ].filter(Boolean);

//   const venuePlannerPath = "/venue-planner#hotels";

//   const statePath =
//     `/venue-planner?state=${encodeURIComponent(
//       hotel.state
//     )}#hotels`;

//   const cityPath =
//     `/venue-planner?state=${encodeURIComponent(
//       hotel.state
//     )}&city=${encodeURIComponent(
//       hotel.city
//     )}#hotels`;

//   return (
//     <>
//       <PageMeta
//         title={`Venue Planner | ${hotel.name} | Atlas Travel House`}
//         description={hotel.description}
//       />

//       <Breadcrumb
//         items={[
//           {
//             label: "Venue Planner",
//             path: venuePlannerPath,
//           },
//           {
//             label: hotel.state,
//             path: statePath,
//           },
//           {
//             label: hotel.city,
//             path: cityPath,
//           },
//           {
//             label: hotel.name,
//           },
//         ]}
//       />

//       <main className={styles.page}>
//         <TableOfContents items={tableOfContents} />

//         <HotelHero hotel={hotel} />

//         <section
//           id="overview"
//           className={styles.overviewSection}
//         >
//           <div className={styles.container}>
//             <div className={styles.overviewContent}>
//               <h2 className={styles.overviewTitle}>
//                 About {hotel.name}
//               </h2>

//               <p className={styles.overviewDescription}>
//                 {hotel.description}
//               </p>
//             </div>
//           </div>
//         </section>

//         {hasInventory && (
//           <section id="inventory">
//             <Inventory inventory={hotel.inventory} />
//           </section>
//         )}

//         {hasVenueSpaces && (
//           <section id="venue-spaces">
//             <VenueSpaces spaces={hotel.venue_spaces} />
//           </section>
//         )}

//         {hasBallrooms && (
//           <section id="ballrooms">
//             <BallroomGrid
//               hotel={hotel}
//               ballrooms={hotel.ballrooms}
//             />
//           </section>
//         )}
//            <section id="hotelsuggestions">
//            <HotelSuggestionForm />         
//     </section>
//       </main>
//     </>
//   );
// }



import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import styles from "./HotelDetails.module.css";
import PageMeta from "../Breadcrumb/PageMeta";
import Breadcrumb from "../Breadcrumb/Breadcrumb";
import BallroomGrid from "../BallroomGrid/BallroomGrid";
import TableOfContents from "../TableOfContents/TableOfContents";
import Inventory from "../Inventory/Inventory";
import VenueSpaces from "../VenueSpaces/VenueSpaces";
import { getVenuePlannerData } from "../venuePlannerApi";
import HotelHero from "./HotelHero";
import HotelSuggestionForm from "../HotelSuggestions/HotelSuggestionForm";
import HotelRecommendInTheCity from "../recommendations/hotelRecommendInTheCity/HotelRecommendInTheCity";
import HotelRecommendInTheState from "../recommendations/hotelRecommendInTheState/HotelRecommendInTheState";

export default function HotelDetails() {
  const { hotelSlug } = useParams();

  const [hotel, setHotel] = useState(null);
  const [allHotels, setAllHotels] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;

    const loadHotel = async () => {
      try {
        setLoading(true);

        const hotels = await getVenuePlannerData();

        if (isMounted) {
          setAllHotels(Array.isArray(hotels) ? hotels : []);
        }

        const selectedHotel = Array.isArray(hotels)
          ? hotels.find((item) => item.slug === hotelSlug)
          : null;

        if (isMounted) {
          setHotel(selectedHotel || null);
        }
      } catch (err) {
        console.error("Failed to load hotel details:", err);

        if (isMounted) {
          setHotel(null);
          setAllHotels([]);
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    loadHotel();

    return () => {
      isMounted = false;
    };
  }, [hotelSlug]);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!hotel) {
    return <div>Hotel not found.</div>;
  }

  const hasInventory =
  hotel.inventory &&
  Object.keys(hotel.inventory).length > 0;

const hasVenueSpaces =
  hotel.venue_spaces?.length > 0;

const hasBallrooms =
  hotel.ballrooms?.length > 0;

const recommendedHotelsCount = allHotels.filter((item) => {
  if (!item || item.slug === hotel.slug) {
    return false;
  }

  return (
    item.city?.trim().toLowerCase() ===
    hotel.city?.trim().toLowerCase()
  );
}).length;

const hasCityRecommendations = recommendedHotelsCount > 0;

const tableOfContents = [
  {
    id: "overview",
    label: "Overview",
  },
  hasInventory && {
    id: "inventory",
    label: "Inventory",
  },
  hasVenueSpaces && {
    id: "venue-spaces",
    label: "Venue Spaces",
  },
  hasBallrooms && {
    id: "ballrooms",
    label: "Ballrooms",
  },
  hasCityRecommendations && {
    id: "city-recommendations",
    label: "Nearby Hotels",
  },
].filter(Boolean);

  const venuePlannerPath = "/venue-planner#hotels";

  const statePath =
    `/venue-planner?state=${encodeURIComponent(
      hotel.state || ""
    )}#hotels`;

  const cityPath =
    `/venue-planner?state=${encodeURIComponent(
      hotel.state || ""
    )}&city=${encodeURIComponent(
      hotel.city || ""
    )}#hotels`;

  return (
    <>
      <PageMeta
        title={`Venue Planner | ${hotel.name} | Atlas Travel House`}
        description={hotel.description}
      />

      <Breadcrumb
        items={[
          {
            label: "Venue Planner",
            path: venuePlannerPath,
          },
          {
            label: hotel.state,
            path: statePath,
          },
          {
            label: hotel.city,
            path: cityPath,
          },
          {
            label: hotel.name,
          },
        ]}
      />

      <main className={styles.page}>
        <TableOfContents items={tableOfContents} />

        <HotelHero hotel={hotel} />

        <section
          id="overview"
          className={styles.overviewSection}
        >
          <div className={styles.container}>
            <div className={styles.overviewContent}>
              <h2 className={styles.overviewTitle}>
                About {hotel.name}
              </h2>

              <p className={styles.overviewDescription}>
                {hotel.description}
              </p>
            </div>
          </div>
        </section>

        {hasInventory && (
          <section id="inventory">
            <Inventory inventory={hotel.inventory} />
          </section>
        )}

        {hasVenueSpaces && (
          <section id="venue-spaces">
            <VenueSpaces spaces={hotel.venue_spaces} />
          </section>
        )}

        {hasBallrooms && (
          <section id="ballrooms">
            <BallroomGrid
              hotel={hotel}
              ballrooms={hotel.ballrooms}
            />
          </section>
        )}

        {hasCityRecommendations && (
  <section id="city-recommendations">
    <HotelRecommendInTheCity
      currentHotel={hotel}
      hotels={allHotels}
    />
    <HotelRecommendInTheState
  currentHotel={hotel}
  hotels={allHotels}
/>
  </section>
)}
        <section id="hotelsuggestions">
          <HotelSuggestionForm />
        </section>
      </main>
    </>
  );
}
